export enum TState {
  INTEGRATIONS = 'integrations',
  ADD = 'add',
  EDIT = 'edit',
  CUT_OFF_TIME = 'cutOffTime',
};